import Vue from 'vue'
import VueRouter from 'vue-router'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '../views/Login.vue'
import Main from '../views/Main.vue'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/main',
    name: 'main',
    component: Main,
    meta: { requiresToken: true },
    redirect: '/manager-list',
    children: [
      {
        path: '/manager-list',
        name: '管理者清單',
        component: () => import('@/views/ManagerList.vue')
      },
      {
        path: '/search-log',
        name: '管理者操作記錄查詢',
        component: () => import('@/views/SearchLog.vue')
      },
      {
        path: '/service-list',
        name: '服務項目管理',
        component: () => import('@/views/ServiceList.vue')
      },
      {
        path: '/staff-list',
        name: '服務人員管理',
        component: () => import('@/views/StaffList.vue')
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About.vue')
      },
      {
        path: '/report-list',
        name: '服務機制系統回報',
        component: () => import('@/views/ReportList.vue')
      },
      {
        path: '/announcement-list',
        name: '公播機制設定列表',
        component: () => import('@/views/AnnouncementList.vue')
      },
      {
        path: '/search-class',
        name: '課程資訊導引服務',
        component: () => import('@/views/SearchClass.vue')
      },
      {
        path: '/environment',
        name: '環境控制系統',
        component: () => import('@/views/Environment.vue')
      },
      {
        path: '/announcement-permission',
        name: '公播機制系統權限設定',
        component: () => import('@/views/AnnouncementPermission.vue')
      },
      {
        path: '/call-log-list',
        name: '呼叫紀錄',
        component: () => import('@/views/CallLogList.vue')
      }
    ]
  },
  {
    path: '/add-manager',
    name: '新增管理者',
    component: () => import('@/views/EditManager.vue')
  },
  {
    path: '/edit-manager/:id',
    name: '編輯管理者',
    component: () => import('@/views/EditManager.vue')
  },
  {
    path: '/add-staff',
    name: '新增服務人員',
    component: () => import('@/views/EditStaff.vue')
  },
  {
    path: '/edit-staff/:id',
    name: '編輯服務人員',
    component: () => import('@/views/EditStaff.vue')
  },
  {
    path: '/add-service',
    name: '新增服務項目',
    component: () => import('@/views/EditService.vue')
  },
  {
    path: '/edit-service/:id',
    name: '編輯服務項目',
    component: () => import('@/views/EditService.vue')
  },
  {
    path: '/log',
    name: '管理者操作記錄',
    component: () => import('@/views/Log.vue')
  },
  {
    path: '/search-report',
    name: '服務機制系統回報查詢',
    component: () => import('@/views/SearchReport.vue')
  },
  {
    path: '/edit-announcement',
    name: '新增公播內容',
    component: () => import('@/views/EditAnnouncement.vue')
  },
  {
    path: '/edit-announcement/:id',
    name: '編輯公播內容',
    component: () => import('@/views/EditAnnouncement.vue')
  },
  {
    path: '/edit-space-message',
    name: '新增訊息內容',
    component: () => import('@/views/EditSpaceMessage.vue')
  },
  {
    path: '/edit-space-message',
    name: '編輯訊息內容',
    component: () => import('@/views/EditSpaceMessage.vue')
  },
  {
    path: '/search-call-log',
    name: '查詢呼叫紀錄',
    component: () => import('@/views/SearchCallLog.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresToken)) {
    if (window.localStorage.getItem('access_token') === null) {
      next({ path: '/login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
